import { keepPreviousData } from '@tanstack/react-query';
import { EnterpriseScopeCounterDiscriminator, useRepositoryQuery } from '@mews-commander/data-access';

export const useCounters = (counterTypes: EnterpriseScopeCounterDiscriminator[]) =>
    useRepositoryQuery(
        'counters',
        'getAll',
        {},
        {
            select: (result) => result.counters.filter((counter) => counterTypes.includes(counter.data.discriminator)),
            placeholderData: keepPreviousData,
            staleTime: 3000,
        }
    );

export const useCounter = (counterId: string) =>
    useRepositoryQuery(
        'counters',
        'getAll',
        {},
        {
            select: (result) => result.counters.find((counter) => counter.id === counterId),
            placeholderData: keepPreviousData,
            staleTime: 3000,
        }
    );
